import { useMutation } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useDeviceCommandSubmit() {
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationFn: (data) => {
      return axiosPrivate({
        method: "POST",
        url: "Control",
        data,
      });
    },
  });
}

export default useDeviceCommandSubmit;
